export enum DealRoomPeopleLogAction {
  VIEW = 'view',
  OPEN_FILE = 'open-file',
  DOWNLOAD = 'download',
  UPLOAD = 'upload',
  UPDATE_UPLOAD = 'update-upload',
  LINK = 'link',
  UPDATE_LINK = 'update-link',
  OPEN_LINK = 'open-link',
  ADD_COMMENT = 'add-comment',
  ADD_COMMENT_FILE = 'add-comment-file',
  DELETE_COMMENT = 'delete-comment',
}
